import { PREVIEW_ARTICLE } from "constants/actionTypes";
import { IPreviewItem } from "modules/Content/interfaces";
import { GLOBAL_ACTION } from "../modules/GlobalActions";
import { IPreviewArticleState } from "../modules/Interface";

/* action type */
interface IArticlePreviewAction {
  type: string;
  payload?: IPreviewItem;
  data?: any;
  loading: boolean;
}

/* defining the initial state with the data type */

const initialActiveArticle = {
  id: 0,
  // articleId: 0,
  title: "",
  description: "",
  image_url: "",
  website: "",
  publishDate: "",
};

const initialState: IPreviewArticleState = {
  openPreview: false,
  activeArticle: initialActiveArticle,
  searchTerms: [],
  loading: false,
};

const previewArticleReducer = (state = initialState, action: IArticlePreviewAction) => {
  const new_state = { ...state };
  switch (action.type) {
    case GLOBAL_ACTION.PREVIEW_LOADING:
      new_state.loading = action.loading;
      return new_state;

    case GLOBAL_ACTION.OPEN_ARTICLE_SIDEBAR_PREVIEW:
      new_state.openPreview = true;
      let n = { ...action.payload };
      let m = { ...state.activeArticle };
      if (typeof n["entities"] === "string") {
        n["entities"] = [];
      }
      new_state.activeArticle = {
        ...m,
        ...n,
      };

      return new_state;
    case GLOBAL_ACTION.ARTICLE_PREVIEW:
      let a = { ...action.payload };
      let b = { ...state.activeArticle };
      if (typeof a["entities"] === "string") {
        a["entities"] = [];
      }
      new_state.activeArticle = {
        ...b,
        ...a,
      };

      return new_state;
    case GLOBAL_ACTION.CLOSE_ARTICLE_SIDEBAR_PREVIEW:
      new_state.openPreview = false;
      new_state.activeArticle = initialActiveArticle;
      return new_state;
    case PREVIEW_ARTICLE.LOAD_SUCCESS:
      let { concepts } = action.data;
      concepts = concepts?.map((item: any) => ({
        name: item.name,
        y: parseFloat(item.relevance),
      }));
      let new_article = {
        ...new_state.activeArticle,
        ...action.data,
        concepts,
      };
      new_state.activeArticle = new_article;
      return new_state;
    case PREVIEW_ARTICLE.UPDATE_SEARCH_TERMS:
      new_state.searchTerms = action.payload;
      return new_state;
    case PREVIEW_ARTICLE.RESET_SEARCH_TERMS:
      new_state.searchTerms = [];
      return new_state;

    case PREVIEW_ARTICLE.RESET:
      new_state.activeArticle = initialActiveArticle;
      new_state.searchTerms = [];
      return new_state;

    default:
      return state;
  }
};

export default previewArticleReducer;
